/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

export enum UserRoles {
  FUNDINGANDFEES = "Fees and Funding",
  FULLDRR = "Full DRR",
  POINTOFSALE = "Point-of-Sale",
  MERCHANT_POS_ADMIN = "Point-of-Sale Admin",
  VOIDREFUND = "Void/Refund"
}
